/******************************************************************/
/******************************************************************/
/***                                                            ***/
/***   CONFIGURATION DES LIENS D'EVITEMENT DE L'APPLICATION :   ***/
/***                                                            ***/
/******************************************************************/
/******************************************************************/
/*
  target peut être un sélecteur css pointant sur tout élément de la page 
  pouvant recevoir le focus, ou un des éléments prédéfinis suivants :
  menu    : première entrée de l'applicationMenu, 
  search  : bouton rechercher de l'applicationHeader, 
  content : premier élément pouvant recevoir le focus dans la zone de contenu de la page, 
  footer  : premier élément pouvant recevoir le focus dans le pied de page

  ex : target : "menu"
  ex : target : "#mydiv > div.btn-group btn:first-child"
*/
const ApplicationSkipLinksConfig = {
  containerClass: 'bg-transparent',
  defaultLinks: [
    { target: "content", text: "Aller au contenu" },
    { target: "menu", text: "Aller au menu" },
    { target: "search", text: "Aller à la recherche" },
    { target: "footer", text: "Aller au pied de page" }
  ],
  pages: [
    {
      name: 'Accueil', links: []
    },
    {
      name: 'Login', links: []
    },
  ]
};

export default ApplicationSkipLinksConfig;
